import { Device } from '@/store/device/types';
import { Prices } from '@/store/prices/types';
import isUSPricing from '@/utils/prices/isUSPricing';
import { FIRST_MONTH_COUPON } from '@/utils/promoOffer/coupons';

export type ActiveOffer =
	| { type: 'firstMonth'; couponId: string; amountOff: number }
	| { type: 'percentOff'; couponId: string; percentOff: number };

export type ActiveOfferType = ActiveOffer['type'];

export const getActiveOffer = (
	prices: Prices | undefined | null,
	device: Device | undefined | null,
): ActiveOffer | null => {
	const monthly = prices?.coupons?.monthly;
	// The first-month offer is only priced for the US. The experiment should never assign it
	// elsewhere, so this guards against a misconfigured arm rather than routing users.
	if (
		monthly?.id === FIRST_MONTH_COUPON &&
		typeof monthly.amount_off !== 'undefined' &&
		isUSPricing(prices, device)
	) {
		return { type: 'firstMonth', couponId: monthly.id, amountOff: monthly.amount_off };
	}
	const yearly = prices?.coupons?.yearly;
	if (typeof yearly?.percent_off !== 'undefined') {
		return { type: 'percentOff', couponId: yearly.id, percentOff: yearly.percent_off };
	}
	return null;
};
